import styles from '../styles/Footer.module.css';

function Footer() {
    const currentYear = new Date().getFullYear();

    return (
        <footer className={styles.footer}>
            <p>&copy; {currentYear} Prashant Nagoorkar. All rights reserved.</p>
        </footer>
    );
}

export default Footer;
